'use client';

import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';

const DEFAULT_INTRO_COPY =
  'Stay in the loop with all the latest print with NIICO products. Our team is constantly on point with the latest and greatest trends, ensuring your space is a timeless treasure.';

export default function NewsMediaPageHeader({
  title = 'In The News',
  introCopy = DEFAULT_INTRO_COPY,
}) {
  return (
    <Box component="section" sx={{ pt: { xs: 4, md: 6 }, pb: { xs: 3, md: 4 } }}>
      <Container maxWidth="lg">
        <Typography component="h1" variant="h4" sx={{ fontWeight: 500, m: 0, mb: 3 }}>
          {title}
        </Typography>
        <Typography sx={{ lineHeight: 1.7, maxWidth: 720 }}>{introCopy}</Typography>
      </Container>
    </Box>
  );
}

NewsMediaPageHeader.propTypes = {
  title: PropTypes.string,
  introCopy: PropTypes.string,
};
